import React, { useState } from "react";
import PropTypes from "prop-types";
import { Trans, t } from "@lingui/macro";

import { useStore } from "base/basestore";
import { i18n } from "base/i18n";
import { Button, BUTTON_SIZES, BUTTON_TYPES } from "widgets/inputs";
import { Alert } from "widgets/feedback";

import { BULK_ACTIONS } from "../../common/constant";
import { Reject } from "../reject_modal";
import { Reassign } from "../reassign_modal";

import styles from "./bulk.actions.toolbar.css";
const { showConfirm } = Alert;

export function BulkActionsToolbar({
  onBulkApprove,
  onBulkReject,
  onBulkReassign,
  onMarkAsCompleted,
  actionButtons,
  onDelete,
  parentComponent
}) {
  const { useStateStore: useGridStore } = useStore();

  const selectedRowsIds = useGridStore((state) => state.selectedRowsIds);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openReassignModal, setOpenReassignModal] = useState(false);

  const avilableActions = {
    [BULK_ACTIONS.SUBMIT]: onApproveClick,
    [BULK_ACTIONS.REJECT]: onRejectClick,
    [BULK_ACTIONS.REASSIGN]: onReaasignClick,
    [BULK_ACTIONS.MARK_AS_COMPLETED]: onMarkAsCompletedClick,
    [BULK_ACTIONS.DELETE]: onDeleteClick
  };
  function onApproveClick() {
    showConfirm({
      title: i18n._(t`Approve items`),
      content: i18n._(
        t`Items that require your inputs will be skipped during the approval`
      ),
      okText: i18n._(t`Proceed`),
      cancelText: i18n._(t`Cancel`),
      onOK: () => {
        onBulkApprove();
      },
      onCancel: () => {}
    });
  }
  function onRejectClick() {
    setOpenRejectModal(true);
  }
  function onReaasignClick() {
    setOpenReassignModal(true);
  }
  function onMarkAsCompletedClick() {
    onMarkAsCompleted();
  }
  function onDeleteClick() {
    onDelete();
  }
  return (
    <div className={styles.container}>
      <div className={styles.flexColumnGap12Container}>
        <span className="smallplus600">
          <Trans>{selectedRowsIds.length} item(s) selected</Trans>
        </span>
        <span
          className={`small ${styles.clearAllLink}`}
          onClick={() => {
            useGridStore.getState().setSelectedRowsIds([]);
          }}
        >
          <Trans>Clear all</Trans>
        </span>
      </div>
      <div className={styles.flexColumnGap12Container}>
        {actionButtons.map((button) => (
          <Button
            key={button.Id}
            size={BUTTON_SIZES.TINY}
            type={BUTTON_TYPES.SECONDARY}
            onClick={avilableActions[button.Id]}
          >
            <Trans>{i18n._(button.label)}</Trans>
          </Button>
        ))}
      </div>
      {openRejectModal && (
        <Reject
          onBulkReject={onBulkReject}
          closeRejectModal={() => setOpenRejectModal(false)}
        />
      )}
      {openReassignModal && (
        <Reassign
          closeReassignModal={() => setOpenReassignModal(false)}
          onBulkReassign={onBulkReassign}
          parentComponent={parentComponent}
        />
      )}
    </div>
  );
}
BulkActionsToolbar.propTypes = {
  actionButtons: PropTypes.array,
  onBulkApprove: PropTypes.func,
  onBulkReassign: PropTypes.func,
  onBulkReject: PropTypes.func,
  onMarkAsCompleted: PropTypes.func,
  onDelete: PropTypes.func,
  parentComponent: PropTypes.string
};
